export var oneCapitalValidator = function oneCapitalValidator(value) {
  return value && !/[A-Z]/g.test(value) ? 'Missing Capital Letter' : undefined;
};
export var oneLowercaseValidator = function oneLowercaseValidator(value) {
  return value && !/[a-z]/g.test(value) ? 'Missing Lowercase Letter' : undefined;
};
export var oneNumberValidator = function oneNumberValidator(value) {
  return value && !/[0-9]/g.test(value) ? 'Missing Number' : undefined;
};
export var minLengthValidator = function minLengthValidator(value) {
  return value && value.length < 6 ? 'Not Long Enough' : undefined;
};
export var passwordsMatchValidator = function passwordsMatchValidator(value, values) {
  return (values.newPassword || value) && value !== values.newPassword ? "Passwords Don't Match" : undefined;
};